import { inject } from '@angular/core';
import { APP_NAME } from '../tokens/app-name.token';

export const getAppName = () => inject(APP_NAME);
